import { createContext } from "react"

export type OverlayLoaderContextValue = {
  setIsOverlayLoaderVisible: (value: boolean) => void;
}

export const OverlayLoaderContext =
  createContext<OverlayLoaderContextValue | null>(null)
